import { rootApi } from 'root-api'

const api = rootApi.injectEndpoints({
  endpoints: (build) => ({
    getReferral: build.query({ query: () => ({ url: '/api/integrations/paypal/referral' }) }),
  })
})

export const { useGetReferralQuery } = api
